import { connect } from 'react-redux';
import { appointmentsSelector } from '@zocdoc-frontend-common/state-user-account/selectors';
import { AppointmentList as View } from './AppointmentList';

function mapStateToProps(state) {
    const appointments = appointmentsSelector(state);
    const enhancedAppointments = appointments.map((appointment) => ({
        ...appointment,
        name: appointment.professional.name,
        title: appointment.professional.title,
        time: appointment.start_time,
        photo:
            appointment.professional.images[0].circularUrl ||
            appointment.professional.images[0].url,
        professionalId: appointment.professional.professional_id || null,
    }));

    return {
        appointments: enhancedAppointments,
    };
}

const AppointmentList = connect(mapStateToProps)(View);

export { AppointmentList };
